import axios from "@/libs/api.request";
// 获取列表
export const getHandleFee = params => {
  return axios.request({
    url: "/finance/cod/handleFee",
    method: "get",
    params
  });
};

export const getDetails = id => {
  return axios.request({
    url: `/finance/cod/handleFee/${id}`,
    method: "get"
  });
};

export const getConfig = () => {
  return axios.request({
    url: "/finance/cod/handleFee/config",
    method: "get"
  });
};

export const add = data => {
  return axios.request({
    url: "/finance/cod/handleFee",
    method: "post",
    data
  });
};

export const del = id => {
  return axios.request({
    url: `/finance/cod/handleFee/${id}`,
    method: "delete"
  });
};

export const update = data => {
  return axios.request({
    url: `/finance/cod/handleFee/${data.id}`,
    method: "put",
    data
  });
};

export const getRules = id => {
  return axios.request({
    url: `/finance/cod/handleFee/getRules/${id}`,
    method: "get"
  });
};

export const getRulesDetails = id => {
  return axios.request({
    url: `/finance/cod/handleFee/readRule/${id}`,
    method: "get"
  });
};

export const createRules = data => {
  return axios.request({
    url: `/finance/cod/handleFee/createRule/${data.id}`,
    method: "post",
    data
  });
};

export const updateRules = data => {
  return axios.request({
    url: `/finance/cod/handleFee/editRule/${data.id}`,
    method: "post",
    data
  });
};

export const delRules = id => {
  return axios.request({
    url: `/finance/cod/handleFee/delRule/${id}`,
    method: "post"
  });
};


export const getCodMethod = () => {
  return axios.request({
    url: `/common/cod_method`,
    method: "get"
  });
};


export const getClientType = () => {
  return axios.request({
    url: `/common/cod_client_type`,
    method: "get"
  });
};

export const getOperator= () => {
  return axios.request({
    url: `/finance/cod/handleFee/operator`,
    method: "get"
  });
};

export const saveRules = data => {
  return axios.request({
    url: `/finance/cod/handleFee/saveRules/${data.id}`,
    method: "post",
    data
  });
};